import { Reveal, Chapter } from "../components/Reveal";

export default function WhyMatters() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="scroll-mt-24 border-t border-ink/10 bg-sand/50 py-24 md:py-32"
    >
      <div className="mx-auto max-w-3xl px-6 text-center">
        <Reveal>
          <div className="flex justify-center">
            <Chapter number="06" label="Why It Matters" />
          </div>
        </Reveal>
        <Reveal delay={60}>
          <h2 className="font-display text-3xl font-medium leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
            The part after the enquiry matters as much as the enquiry itself
          </h2>
        </Reveal>
        <Reveal delay={140}>
          <p className="mt-8 text-base leading-relaxed text-ink/70 md:text-lg">
            Most private practices already invest in generating enquiries —
            through search, advertising, referrals and social media. That
            investment only pays off when enquiries turn into booked
            consultations. Leadtochair focuses on the part after the enquiry:
            getting more value from the interest you&apos;re already
            generating, rather than asking you to spend more on generating it.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
